/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:23 2019-07-15
 */

import EnumItem, { enumMixn } from './enumItem';

/**
 * 因子参数
 */
let EnumDivisorParams = {
    'i13002-Info': new EnumItem('测量精度', null, 'i13002-Info'),
    'i13004-Info': new EnumItem('消解温度', null, 'i13004-Info'),
    'i13005-Info': new EnumItem('消解时长', null, 'i13005-Info'),
    'i13007-Info': new EnumItem('曲线截距', null, 'i13007-Info'),
    'i13008-Info': new EnumItem('曲线斜率', null, 'i13008-Info'),
    'i13009-Info': new EnumItem('测量检出限', null, 'i13009-Info'),
    'i130010-Info': new EnumItem('测量信号值', null, 'i130010-Info'),
    'i130011-Info': new EnumItem('线性相关系数', null, 'i130010-Info'),
    'i130012-Info': new EnumItem('二次多项式系数', null, 'i130010-Info'),
    'i130013-Info': new EnumItem('标准样校准时间', null, 'i130010-Info'),
    'i70001-Info': new EnumItem('量程下限', null, 'i70001-Info'),
    'i70002-Info': new EnumItem('量程上限', null, 'i70002-Info'),
    'i70003-Info': new EnumItem('标定日期', null, 'i70003-Info'),
    'i70004-Info': new EnumItem('标液一浓度', null, 'i70004-Info'),
    'i70005-Info': new EnumItem('标液一测量值', null, 'i70005-Info'),
    'i70006-Info': new EnumItem('标液二浓度', null, 'i70006-Info'),
    'i70007-Info': new EnumItem('标液二测量值', null, 'i70007-Info'),
    'i70008-Info': new EnumItem('校准系数', null, 'i70008-Info'),
    'i70009-Info': new EnumItem('设备序列号', null, 'i70009-Info'),
    'i70010-Info': new EnumItem('校准间隔（天）', null, 'i70010-Info'),
    'i70011-Info': new EnumItem('校准间隔（时）', null, 'i70011-Info'),
    'i70012-Info': new EnumItem('周期测量', null, 'i70012-Info'),
    'i70013-Info': new EnumItem('显色温度', null, 'i70013-Info'),
    'i70014-Info': new EnumItem('显色时间', null, 'i70014-Info'),
    'i70015-Info': new EnumItem('测量间隔', null, 'i70015-Info'),
    ...enumMixn,
};
export default EnumDivisorParams;
